export const emailVariables = [
    'Event Name',
    'Event Description',
    'Org Name',
    'Event Duration',
    'Event Organizer Name',
    'Invitee Name',
    'Invitee Email',
    'Invitee Phone Number',
    'Invitee Notes',
    'Meeting Link',
    'Booking Time and Date with Timezone',
    'Name',
    'Email',
    'Phone no'
];

export const domainSellerList = [
    'GoDaddy',
    'Namecheap',
    'Google',
    'Squarespace',
    'Cloudflare',
    'Bluehost',
    'HostGator',
    'Wix',
    'Shopify',
    'Dynadot',
    'Name.com',
    'Ionos / 1&1',
    'DreamHost',
    'Gandi.net',
    'Network Solutions',
    'Amazon Route 53',
    'Google Workspace',
    'Porkbun',
    'Other'
];